import { useEffect, useRef } from 'react';
import { useAnimation } from 'framer-motion';
import { useIntersectionObserver } from 'usehooks-ts';

import { asIntersectionObserverRef } from '../../../utils/hooks';
import VerticalBorder from '../../../uiParts/VerticalBorder/VerticalBorder';
import LazyLoadImage from '../../../uiParts/LazyLoadImage/LazyLoadImage';
import FadeIn from '../../../uiParts/FadeIn/FadeIn';
import Section from '../../../uiParts/Sections/Section/Section';

import styles from './ProjectLogo.module.css';

interface IProps {
  logo: string;
}

export default function ProjectLogo({ logo }: IProps) {
  const control = useAnimation();
  const logoControl = useAnimation();
  const ref = useRef<HTMLElement>(null);
  const entry = useIntersectionObserver(asIntersectionObserverRef(ref), {
    root: null,
    rootMargin: '20px',
    threshold: 0.5,
    freezeOnceVisible: true,
  });
  const isVisible = !!entry?.isIntersecting;

  useEffect(() => {
    control.start({
      height: '50px',
      transition: {
        duration: 1,
      },
    });

    logoControl.start('show');
  }, [isVisible, control, logoControl]);

  return (
    <Section ref={ref} className={styles.section}>
      <VerticalBorder control={control} />
      <FadeIn yOffset={10} duration={1} controls={logoControl}>
        <LazyLoadImage src={logo} alt="test" />
      </FadeIn>
    </Section>
  );
}
